module.exports = __webpack_public_path__ + "img/honour2.5dfcda5d.png";